/** Used for unit testing. */
export const makeAddress = (options = {}) => ({
  apoFpoNotApplicable: { applicable: true },
  cityUnknown: { applicable: true },
  country: null,
  countryNotApplicable: { applicable: true },
  isMilitaryDiplomaticAddress: {},
  militaryInstallationNameNotApplicable: { applicable: true },
  stateUnknown: { applicable: true },
  streetUnknown: { applicable: true },
  zipcodeUnknown: { applicable: true },
  ...(options || {}),
});
